import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import type { Plan } from "../api";

export type { Plan, PlanPrice, PlanPriceInterval } from "../api";

export function usePlans(options: { marketing?: boolean; pricing?: boolean } = {}) {
  const { marketing, pricing } = options;
  const key = marketing ? "marketing" : pricing ? "pricing" : "all";
  return useQuery<Plan[]>({
    queryKey: ["plans", key],
    queryFn: () => api.getPlans({ marketing, pricing }).then((r) => r.data.plans),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
